'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {

	/*@ngInject*/
	function _class($http, $filter, data) {
		_classCallCheck(this, _class);

		this.selectedTutor = [];

		this.$http = $http;
		this.data = data;
		this.instance = this.data.aInstance;
		this.initialTutor = this.data.tutorUID;
	}

	_createClass(_class, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.colors = ['blue', 'orange', 'red', 'purple', 'grey', 'green', 'yellow', 'lime'];
			this.tab = 'instance';

			this.$http.get('/api/tutors').then(function (res) {
				_this.tutors = res.data;
				var foundTutor = _this.tutors.find(function (t) {
					return t._id === _this.data.tutorUID;
				});
				_this.selectedTutor = foundTutor ? [foundTutor] : [];
			});
		}
	}, {
		key: 'returnName',
		value: function returnName(data) {
			if (data.overwriteName && data.overwriteName[data.aInstance]) {
				return data.overwriteName[data.aInstance];
			};

			return data.student.firstName + ' ' + data.student.lastName;
		}
	}, {
		key: 'returnFilter',
		value: function returnFilter(results, $query) {
			return results.filter(function (item) {
				if (item.isActive === false) {
					return false;
				}
				return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
			});
		}
	}, {
		key: 'submit',
		value: function submit(data, callback) {
			var _this2 = this;

			if (this.selectedTutor.length === 0) {
				this.error = 'Please enter a tutor.';
				return;
			}

			var instance = data.aInstance;

			if (this.lastInstance) {
				data.instances = instance + 1;
			}

			data.tutorUID = this.selectedTutor[0]._id;

			this.$http.put('/api/lessons/' + data._id, data).then(function (res) {
				_this2.error = '';
				callback({ reason: 'success', data: res.data });
			}).catch(function (res) {
				console.log(res);
				_this2.error = JSON.stringify(res.data, null, '\t');
			});
		}
	}]);

	return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/calendar/modal/edit.session.controller.js